import { clerkWalletDeposit, clerkWalletRecover, clerkWalletDisable, depositWalletSearch } from '@/utils/api';
import i18n from '@/utils/i18n';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import { printDepositTicket } from '@/plugins/printFactory';
import snq from 'snq';

Vue.use(Vuex);

function getCustomRanges() {
  return [
    {
      name: i18n.t('GamesRangePicker.Today'),
      rangeStart: moment(),
      rangeEnd: moment(),
    },
    {
      name: i18n.t('GamesRangePicker.Yesterday'),
      rangeStart: moment().add(-1, 'days'),
      rangeEnd: moment().add(-1, 'days'),
    },
    {
      name: i18n.t('GamesRangePicker.Last Week'),
      rangeStart: moment()
        .add(-1, 'weeks')
        .startOf('isoWeek'),
      rangeEnd: moment()
        .add(-1, 'weeks')
        .add(1, 'days')
        .endOf('isoWeek'),
    },
    {
      name: i18n.t('GamesRangePicker.This Month'),
      rangeStart: moment().startOf('month'),
      rangeEnd: moment().endOf('month'),
    },
    {
      name: i18n.t('GamesRangePicker.Last 3 Months'),
      rangeStart: moment()
        .add(-2, 'M')
        .startOf('month'),
      rangeEnd: moment().endOf('month'),
    },
    {
      name: i18n.t('GamesRangePicker.This Year'),
      rangeStart: moment().startOf('year'),
      rangeEnd: moment().endOf('year'),
    },
  ];
}

const getDefaultState = () => {
  return {
    amount: 25,
    renewCode: null,
    depositStatus: {
      loading: false,
      success: false,
      error: false,
    },
    deposits: [],
    depositsSearchStatus: {
      loading: false,
      success: false,
      error: false,
    },
    depositsTop: [],
    depositsTopSearchStatus: {
      loading: false,
      success: false,
      error: false,
    },
    depositsDisabled: [],
    depositsDisabledSearchStatus: {
      loading: false,
      success: false,
      error: false,
    },
    disableWalletStatus: {
      success: false,
      error: false,
    },
    selectedRange: 0,
    selectedRangeFilter: {
      startDate: new Date(moment()),
      endDate: new Date(moment()),
    },
    recoveringTicketNumbers: {},
    printerStatus: { loading: false },
    wagerTicket: null,
    ticketPaidBy: null
  };
};
const state = getDefaultState();

const getters = {
  getField,
  transactionsTableFields: _ => [
    {
      key: 'ticket_number',
      label: i18n.t('ClerkDeposit.TicketNumber'),
      _searchable: true,
      _sortable: true,
    },
    {
      key: 'SoldDate',
      label: i18n.t('ClerkDeposit.LastModify'),
      _searchable: true,
      _sortable: true,
    },
    {
      key: 'SoldValue',
      label: i18n.t('Amount'),
      _searchable: true,
      _sortable: true,
    },
    {
      key: 'VoucherWithdrawableBalance',
      label: i18n.t('ClerkDeposit.Balance'),
      _searchable: true,
      _sortable: true,
    },
    {
      key: 'options',
      label: i18n.t('ClerkDeposit.Options'),
      _searchable: false,
      _sortable: false,
    },
  ],
  customRanges: _ => getCustomRanges(),

  getWagerTicket: state => state.wagerTicket,

  getTicketPaidBy: state => state.ticketPaidBy

};

const mutations = {
  updateField,
  setDepositStatus(state, row) {
    state.depositStatus = {
      ...state.depositStatus,
      ...row,
    };
  },
  setDepositsSearchStatus(state, row) {
    state.depositsSearchStatus = {
      ...state.depositsSearchStatus,
      ...row,
    };
  },
  setDepositsTopSearchStatus(state, row) {
    state.depositsTopSearchStatus = {
      ...state.depositsTopSearchStatus,
      ...row,
    };
  },
  setDepositsDisabledSearchStatus(state, row) {
    state.depositsDisabledSearchStatus = {
      ...state.depositsDisabledSearchStatus,
      ...row,
    };
  },
  setDisableWalletStatus(state, row) {
    state.disableWalletStatus = {
      ...state.disableWalletStatus,
      ...row,
    };
  },
  setDeposits(state, deposits) {
    state.deposits = deposits;
  },
  setDepositsTop(state, depositsTop) {
    state.depositsTop = depositsTop;
  },
  setDepositsDisabled(state, depositsDisabled) {
    state.depositsDisabled = depositsDisabled;
  },
  addRecoveringTicketNumber(state, ticket_number) {
    Vue.set(state.recoveringTicketNumbers, ticket_number, 1);
  },
  removeRecoveringTicketNumber(state, ticket_number) {
    Vue.delete(state.recoveringTicketNumbers, ticket_number);
  },
  setRenewCode(state, d) {
    state.renewCode = d;
  },
  setPrinterStatus(state, data) {
    state.printerStatus = data;
  },

  SET_WAGER_TICKET(state, ticket) {
    state.wagerTicket = ticket;
  },

  SET_TICKET_PAID_BY(state, name) {
    state.ticketPaidBy = name;
    console.log(state.ticketPaidBy);
  }

};

const actions = {
  tryClerkWalletDeposit({ commit, rootState, state, dispatch }) {
    commit('setDepositStatus', { loading: true });
    const formData = {
      amount: state.amount,
      description: 'Deposited amount: ' + state.amount,
      user_id: rootState.player.clerk.user_id,
      mac_address: rootState.settings.macAddress,
      reference: 'TEST',
    };
    clerkWalletDeposit(formData).then(r => {
      if (r.data.IsSuccess && snq(() => r.data.Data.data.scan_code)) {
        commit('setDepositStatus', { success: r.data.Data.data, error: false, openModalSuccess: false });
        dispatch('tryDepositsSearch');

        const ticketJson = {
          scan_code: state.depositStatus.success.scan_code,
          //amount: state.amount,
          amount: r.data.Data.data.available_balance,
          ticket_number: state.depositStatus.success.ticket_number,
          currency: rootState.settings.terminalInfo.currency_name,
        };

        printDepositTicket({
          clientType: rootState.settings.clientType,
          ticketJson,
          callback: function(arg) {
            dispatch('settings/getClerkBalance', null, { root: true });
            commit('clerkDepositStore/setPrinterStatus', { success: arg.success }, { root: true });
          },
        });
      } else {
        commit('setDepositStatus', {
          success: false,
          error: true,
          openModalSuccess: false,
          openModalVoided: false,
        });
      }
      commit('setDepositStatus', { loading: false, openModalSuccess: false, openModalVoided: false });
    });
  },
  tryDepositsSearch({ commit, rootState, getters }, selectedTerminalId) {
    commit('setDepositsSearchStatus', { loading: true });
    commit('setDeposits', []);
    const selectedRangeFilter = state.selectedRangeFilter;
    let from;
    let to;

    if (selectedRangeFilter.startDate && selectedRangeFilter.endDate) {
      from = moment(selectedRangeFilter.startDate)
        .startOf('day')
        .format('YYYY-MM-DD HH:mm');
      to = moment(selectedRangeFilter.endDate)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm');
    } else {
      from = getters['customRanges'][state.selectedRange].startDate;
      to = getters['customRanges'][state.selectedRange].endDate;
    }

    const formData = {
      mac_address: rootState.settings.macAddress,
      //from: moment(from).format('YYYY-MM-DD 00:00:00'),
      //to: moment(to).format('YYYY-MM-DD 23:59:59'),
      from: moment().format('YYYY-MM-DD 00:00:00'),
      to: moment().format('YYYY-MM-DD 23:59:59'),
      user_id: rootState.player.clerk.user_id,
      terminal_id: selectedTerminalId || rootState.settings.terminalInfo.terminal_id,
    };
    depositWalletSearch(formData).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data.status == 'ok') {
          // get first 10
          commit(
            'setDeposits',
            snq(() => r.data.Data.data.filter((_, idx) => idx < 10)),
            [],
          );
        } else {
          commit('setDepositsSearchStatus', { success: false, error: true });
        }
      } else {
        commit('setDepositsSearchStatus', { success: false, error: true });
      }
      commit('setDepositsSearchStatus', { loading: false });
    });
  },
  tryDepositsTopSearch({ commit, rootState, getters }, selectedTerminalId) {
    commit('setDepositsTopSearchStatus', { loading: true });
    commit('setDepositsTop', []);
    const selectedRangeFilter = state.selectedRangeFilter;
    let from;
    let to;

    if (selectedRangeFilter.startDate && selectedRangeFilter.endDate) {
      from = moment(selectedRangeFilter.startDate)
        .startOf('day')
        .format('YYYY-MM-DD HH:mm');
      to = moment(selectedRangeFilter.endDate)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm');
    } else {
      from = getters['customRanges'][state.selectedRange].startDate;
      to = getters['customRanges'][state.selectedRange].endDate;
    }

    const formData = {
      mac_address: rootState.settings.macAddress,
      //from: moment(from).format('YYYY-MM-DD 00:00:00'),
      //to: moment(to).format('YYYY-MM-DD 23:59:59'),
      from: moment().format('YYYY-MM-DD 00:00:00'),
      to: moment().format('YYYY-MM-DD 23:59:59'),
      user_id: rootState.player.clerk.user_id,
      terminal_id: selectedTerminalId || rootState.settings.terminalInfo.terminal_id,
      status: '1',
    };
    console.log(formData);
    depositWalletSearch(formData).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data.status == 'ok') {
          // get first 10
          commit(
            'setDepositsTop',
            snq(() => r.data.Data.data.filter((_, idx) => idx < 10)),
            [],
          );
        } else {
          commit('setDepositsTopSearchStatus', { success: false, error: true });
        }
      } else {
        commit('setDepositsTopSearchStatus', { success: false, error: true });
      }
      commit('setDepositsTopSearchStatus', { loading: false });
    });
  },
  tryDepositsDisabledSearch({ commit, rootState, getters }, selectedTerminalId) {
    commit('setDepositsDisabledSearchStatus', { loading: true });
    commit('setDepositsDisabled', []);
    const selectedRangeFilter = state.selectedRangeFilter;
    let from;
    let to;

    if (selectedRangeFilter.startDate && selectedRangeFilter.endDate) {
      from = moment(selectedRangeFilter.startDate)
        .startOf('day')
        .format('YYYY-MM-DD HH:mm');
      to = moment(selectedRangeFilter.endDate)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm');
    } else {
      from = getters['customRanges'][state.selectedRange].startDate;
      to = getters['customRanges'][state.selectedRange].endDate;
    }

    const formData = {
      mac_address: rootState.settings.macAddress,
      //from: moment(from).format('YYYY-MM-DD 00:00:00'),
      //to: moment(to).format('YYYY-MM-DD 23:59:59'),
      from: moment().format('YYYY-MM-DD 00:00:00'),
      to: moment().format('YYYY-MM-DD 23:59:59'),
      user_id: rootState.player.clerk.user_id,
      terminal_id: selectedTerminalId || rootState.settings.terminalInfo.terminal_id,
      status: '0',
    };
    console.log(formData);
    depositWalletSearch(formData).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data.status == 'ok') {
          // get first 10
          commit(
            'setDepositsDisabled',
            snq(() => r.data.Data.data.filter((_, idx) => idx < 10)),
            [],
          );
        } else {
          commit('setDepositsDisabledSearchStatus', { success: false, error: true });
        }
      } else {
        commit('setDepositsDisabledSearchStatus', { success: false, error: true });
      }
      commit('setDepositsDisabledSearchStatus', { loading: false });
    });
  },
  tryClerkWalletRecover({ rootState, dispatch, commit }, { ticket_number }) {
    commit('addRecoveringTicketNumber', ticket_number);
    const formData = {
      user_id: rootState.player.clerk.user_id,
      mac_address: rootState.settings.macAddress,
      wallet_id: ticket_number,
      comment: 'Recover process for ' + ticket_number,
    };
    clerkWalletRecover(formData).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data.status === 'ok') {
          if (r.data.Data.data && r.data.Data.data[0]) {
            const newScanCode = r.data.Data.data[0].scan_code;
            const soldValue = r.data.Data.data[0].sold_value;
            commit('setRenewCode', newScanCode);
            dispatch('tryDepositsSearch');

            const ticketJson = {
              scan_code: newScanCode,
              amount: soldValue,
              ticket_number: ticket_number,
            };
            printDepositTicket({
              clientType: rootState.settings.clientType,
              ticketJson,
              callback: function(arg) {
                dispatch('settings/getClerkBalance', null, { root: true });
                commit('clerkDepositStore/setPrinterStatus', { success: arg.success }, { root: true });
              },
            });
          }
        }
      }
      commit('removeRecoveringTicketNumber', ticket_number);
    });
  },
  tryClerkWalletDisable({ rootState, dispatch, commit }, { ticket_number }) {
    commit('addRecoveringTicketNumber', ticket_number);
    const formData = {
      user_id: rootState.player.clerk.user_id,
      mac_address: rootState.settings.macAddress,
      wallet_id: ticket_number,
      comment: 'Disable process for ' + ticket_number,
    };
    clerkWalletDisable(formData).then(r => {
      if (
        r.data.IsSuccess &&
        r.data.Data.status === 'ok' &&
        r.data.Data.data &&
        r.data.Data.data[0] &&
        r.data.Data.data[0].status == '0'
      ) {
        commit('setDisableWalletStatus', {
          success: i18n.t('ClerkDeposit.DisableWalletSuccess', [r.data.Data.data[0].ticket_number]),
          error: false,
        });
        dispatch('settings/getClerkBalance', null, { root: true });
        dispatch('tryDepositsSearch');
      } else {
        commit('setDisableWalletStatus', {
          error: i18n.t('ClerkDeposit.DisableWalletFailed'),
          success: false,
        });
      }
      commit('removeRecoveringTicketNumber', ticket_number);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
